// About the Startup section configuration
// Defines fields, validation, and metadata for basic startup info
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Schema for social link item (single url field)
const socialLinkSchema = z.object({
  url: z.string().url('Must be a valid URL'),
});

// Validation schema for about section
export const aboutSectionSchema = z.object({
  logo: z.any().optional(), // File validation handled separately
  name: z.string().min(1, 'Startup name is required'),
  description: z.string().min(1, 'Description is required'),
  country: z.array(z.string()).min(1, 'At least one country is required'),
  cities: z.array(z.string()).min(1, 'At least one city is required'),
  socialLinks: z.array(socialLinkSchema).optional(),
});

export type AboutSectionData = z.infer<typeof aboutSectionSchema>;

// Section config
export const aboutSection: SectionConfig = {
  id: 'about',
  titleKey: 'Sobre la StartUp',
  //descriptionKey: 'Información básica sobre tu startup',
  validationSchema: aboutSectionSchema,
  fields: [
    {
      name: 'logo',
      type: 'file',
      label: 'Logo de la Startup',
      required: false,
      //helpText: 'Sube el logo de tu startup',
    },
    {
      name: 'name',
      type: 'text',
      label: 'Nombre de la Startup / PyMe',
      placeholder: 'Ingresa el nombre de tu startup',
      required: true,
      maxLength: 100,
    },
    {
      name: 'description',
      type: 'textarea',
      label: 'Descripción de tu empresa',
      placeholder: 'Describe brevemente tu startup...',
      required: true,
      maxLength: 100,
      aiEnabled: true,
    },
    {
      name: 'country',
      type: 'multiselectDropdown',
      label: 'País donde opera',
      placeholder: 'Selecciona un país',
      required: true,
      options: [
        { value: 'CR', label: 'Costa Rica' },
        { value: 'CO', label: 'Colombia' },
        { value: 'MX', label: 'México' },
        { value: 'PA', label: 'Panamá' },
        { value: 'GT', label: 'Guatemala' },
        { value: 'SV', label: 'El Salvador' },
        { value: 'HN', label: 'Honduras' },
        { value: 'NI', label: 'Nicaragua' },
      ],
    },
    {
      name: 'cities',
      type: 'multiselectDropdown',
      label: 'Ciudades donde opera',
      required: true,
      options: [
        { value: 'san-jose', label: 'San José' },
        { value: 'cali', label: 'Cali' },
        { value: 'bogota', label: 'Bogotá' },
        { value: 'medellin', label: 'Medellín' },
        { value: 'ciudad-mexico', label: 'Ciudad de México' },
        { value: 'guadalajara', label: 'Guadalajara' },
        { value: 'monterrey', label: 'Monterrey' },
      ],
    },
    {
      name: 'socialLinks',
      type: 'repeater',
      label: 'Redes sociales',
      required: true,
      addButtonLabel: '',
      itemLabelPrefix: '',
      itemFields: [
        {
          name: 'url',
          type: 'url',
          label: '',
          required: false,
          placeholder: 'https://',
        },
      ],
    },
  ],
};
